export type GetRoutePathParams = {
  routeKey: string;
  customerId?: string | number;
  accountId?: string | number;
  cardId?: string | number;
  transactionNo?: string | number;
  activityLogId?: string | number;
  fileId?: string | number;
  isCorporate?: boolean;
};

const getRoutePath = ({
  routeKey,
  customerId,
  accountId,
  cardId,
  transactionNo,
  activityLogId,
  fileId,
  isCorporate,
}: GetRoutePathParams): string => {
  switch (routeKey) {
    case 'dashboard':
      return `/${customerId}/dashboard`;

    case 'messages':
      return `/${customerId}/messages`;

    case 'accounts':
      return `/${customerId}/accounts`;

    case 'account-details':
      return `/${customerId}/accounts/${accountId}/details`;

    case 'account-topup':
      return `/${customerId}/accounts/${accountId}/topup`;

    case 'account-transactions':
      return `/${customerId}/accounts/${accountId}/transactions`;

    case 'account-transaction-details':
      return `/${customerId}/accounts/${accountId}/transaction/${transactionNo}/details`;

    case 'account-transaction-authorization-details':
      return `/${customerId}/transfers/mandates/${transactionNo}/details`;

    case 'cards':
      return `/${customerId}/individual/cards`;

    case 'issue-card':
      return `/${customerId}/individual/cards/issue-card`;

    case 'consent-card':
      return `/${customerId}/individual/cards/consent-card`;

    case 'request-card':
      return `/${customerId}/individual/cards/request-card`;

    case 'issue-corporate-card':
      return `/${customerId}/corporate/cards/issue-card`;

    case 'card-details':
      return `/${customerId}/${isCorporate ? 'corporate' : 'individual'}/card/${cardId}/details`;

    case 'transactions':
      return `/${customerId}/transactions`;

    case 'transaction-details':
      return `/${customerId}/transactions/${transactionNo}/details`;

    case 'authorizations':
      return `/${customerId}/transfers/mandates`;

    case 'recurring-orders':
      return `/${customerId}/recurring-orders`;

    case 'beneficiaries':
      return `/${customerId}/beneficiaries`;

    case 'create-beneficiary':
      return `/${customerId}/beneficiaries/new`;

    case 'user-profile':
      return `/${customerId}/user-profile`;

    case 'device-management':
      return `/${customerId}/device-management`;

    case 'communication-preferences':
      return `/${customerId}/communication-preferences`;

    case 'gdpr-policy':
      return `/${customerId}/policies/gdpr`;

    case 'security-preferences':
      return `/${customerId}/security-preferences`;

    case 'security-preferences-change-password':
      return `/${customerId}/security-preferences/change-password`;

    case 'security-preferences-change-username':
      return `/${customerId}/security-preferences/change-username`;

    case 'exchange-calculator':
      return `/${customerId}/exchange-calculator`;

    case 'error':
      return `/${customerId}/error`;

    case 'mass-payments':
      return `/${customerId}/mass-payments`;

    case 'payroll':
      return `/${customerId}/payroll`;

    case 'new-payroll':
      return `/${customerId}/payroll/new`;

    case 'payroll-details':
      return `/${customerId}/payroll/${fileId}/details`;

    case 'card-transaction-details':
      return `/${customerId}/${
        isCorporate ? 'corporate' : 'individual'
      }/card/${cardId}/transaction/${transactionNo}/details`;

    case 'top-up-card':
      return `/${customerId}/${isCorporate ? 'corporate' : 'individual'}/card/${cardId}/topup`;

    case 'terminate-card':
      return `/${customerId}/${isCorporate ? 'corporate' : 'individual'}/card/${cardId}/terminate`;

    case 'activate-card':
      return `/${customerId}/${isCorporate ? 'corporate' : 'individual'}/card/${cardId}/activate`;

    case 'replace-card':
      return `/${customerId}/${isCorporate ? 'corporate' : 'individual'}/card/${cardId}/replace`;

    case 'reset-pin-attempts':
      return `/${customerId}/${isCorporate ? 'corporate' : 'individual'}/card/${cardId}/reset-pin-attempts`;

    case 'permanent-block-card':
      return `/${customerId}/${isCorporate ? 'corporate' : 'individual'}/card/${cardId}/permanent-block`;

    case 'terms-conditions':
      return `/${customerId}/termsCondition`;

    case 'favorite-transfers':
      return `/${customerId}/favorite-transfers`;

    case 'fund-transfer':
      return `/${customerId}/fund-transfer`;

    case 'activity-log':
      return `/${customerId}/activity-log`;

    case 'activity-log-details':
      return `/${customerId}/activity-log/${activityLogId}/details`;

    case 'new-account':
      return `/${customerId}/accounts/new`;

    case 'corporate-cards':
      return `/${customerId}/corporate/cards`;

    default:
      return '/';
  }
};

export { getRoutePath };
